<div class="container-fluid p-0 flex justify-center items-center" style="height: 100vh; overflow: auto; background-color: var(--tis-primary);">
    <div class="bg-white p-8 rounded-lg shadow-xl flex flex-col items-center space-y-6 max-w-sm w-full mx-4">
        <div class="relative">
            <img class="mx-auto h-10 w-auto" src="assets/logo/cantrak-logo.svg" alt="Cantrak">
        </div>
        <h1 class="text-2xl font-bold text-gray-800">Logging in by QR</h1>
        @if(errorMessage){
            <p class="tis-text-danger text-center">
                {{errorMessage}}
            </p>
        }
        @else{
            <p class="text-gray-600 text-center">
                Please wait while we securely log you in using QR Code.
            </p>
        }
        <div class="flex items-center space-x-2" *ngIf="loading">
            <div class="w-3 h-3 rounded-full animate-bounce" style="background-color: var(--tis-primary);"></div>
            <div class="w-3 h-3 rounded-full animate-bounce" style="animation-delay: 0.2s; background-color: var(--tis-primary);"></div>
            <div class="w-3 h-3 rounded-full animate-bounce" style="animation-delay: 0.4s; background-color: var(--tis-primary);"></div>
        </div>
    </div>
</div>